import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import cogoToast from "cogo-toast";
import ClarificationItemComponent from "./components/clarification-details";
import ListViewComponent from "../Patients/patientsListView";
import clarificationsService from "../../../../services/clarifications-service";
import CLARIFICATION_EMPTY_STATE from '../../../../assets/img/clarification-no-data.png';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


const ClarificationsComponent = () => {

    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [clarificationsListData, setClarificationsListData] = useState([]);
    const [clarificationItem, setClarificationItem] = useState({});
    const [selectedClarificationItemIndex, setSelectedClarificationItemIndex] = useState(0);
    const [showEmptyState, setShowEmptyState] = useState(false);

    useEffect(() => {
        getClarificationsData();
    }, [])

    const getClarificationsData = async () => {
        try {
            const clarificationsDataResponse = await clarificationsService.getClarificationsData();
            if (!clarificationsDataResponse || clarificationsDataResponse.length === 0) {
                setShowEmptyState(true);
                setLoading(false);
                return;
            }
            setClarificationsListData(clarificationsDataResponse);
            setClarificationItem(clarificationsDataResponse[0] || {});
            setSelectedClarificationItemIndex(0);
        } catch (error) {
            const { hide } = cogoToast.error(
                "Error getting Clarifications Data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
        setLoading(false);
    }
    
    function modifyAndFilter(response, keyMap, filterKeys) {
        const newResp = [];
        for (const item of response) {
            let obj = {};
            for (const oldKey in item) {
                if (item.hasOwnProperty(oldKey)) {
                    if (filterKeys.includes(oldKey)) {
                        const newKey = keyMap[oldKey] || oldKey;
                        obj[newKey] = item[oldKey];
                    }
                }
            }
            obj['Response/Notes'] = "";
            newResp.push(obj);
        }
        return newResp;
    }
    const MIN_COLUMN_WIDTH = 15;
    const MAX_COLUMN_WIDTH = 40;

    const exportToExcel = async (resp) => {
        const keyMap = {
            pat_name: "Patient Name",
            pat_acct_num: "Patient Account Number",
            pat_dob: "Patient DOB",
            drg: "Drug Name",
            provider: "Provider",
            fac_name: "Facility",
            sig_direction: "SIG/Directions",
            clarification: "Clarification Needed",
        };
        const filterKeys = ["pat_name", "pat_acct_num", "pat_dob", "drg", "provider", "fac_name", "sig_direction", "clarification"];

        const data = modifyAndFilter(resp, keyMap, filterKeys);
        const columnKeys = Object.keys(data[0] || {});

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        worksheet.columns = columnKeys.map((key) => {
            const longestContentLength = data.reduce((max, row) => {
                const cellValue = row[key] == null ? "" : String(row[key]);
                return Math.max(max, cellValue.length);
            }, key.length);
            return {
                header: key,
                key,
                width: Math.min(Math.max(longestContentLength + 2, MIN_COLUMN_WIDTH), MAX_COLUMN_WIDTH),
            };
        });

        worksheet.addRows(data);

        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = { wrapText: true, vertical: 'top', horizontal: 'left' };
            });
        });
        worksheet.getRow(1).font = { bold: true };

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'clarifications.xlsx');
    };

    const handleOnClarificationClick = (item, index) => {
        setClarificationItem(item);
        setSelectedClarificationItemIndex(index);
    }

    const handleOnSubmitClick = async (item) => {
        setLoading(true);
        setIsSubmitting(true);
        try {
            await clarificationsService.submitClarifications(item);
            await getClarificationsData();
        } catch (error) {
            const { hide } = cogoToast.error(
                "Error submitting Clarifications Data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
        setLoading(false);
        setIsSubmitting(false);
    }

    return (
        <>
            <div className="my-4  flex justify-end  w-full">
                <button
                    onClick={() => exportToExcel(clarificationsListData)}
                    class="bg-header_bg rounded  py-2 px-7 cursor-pointer text-sm font-bold text-white h-10 inline-block shadow-md leading-6 mr-2"
                >
                    Download
                </button>
            </div>
            <div className="h-full mt-0 flex flex-row gap-4 p-4 border-2 rounded-2xl rounded-tl-none justify-center">
                <div
                    className={`inline-block customtop absolute ${loading ? "show" : "hidden"
                        }`}
                >
                    <Loader
                        type="Oval"
                        color="#00BFFF"
                        height={50}
                        width={50}
                        timeout={300000}
                    />
                </div>

                {clarificationsListData.length > 0 && !showEmptyState && (
                    <>
                        <div className="flex flex-col lg:flex-row w-2/5 h-full overflow-scroll">
                            <ListViewComponent
                                list={clarificationsListData}
                                onListItemClick={handleOnClarificationClick}
                                selectedIndex={selectedClarificationItemIndex}
                            />
                        </div>

                        <div className="w-full lg:w-2/3 bg-white rounded-2xl shadow-2xl h-full overflow-scroll">
                            <ClarificationItemComponent
                                clarificationItem={clarificationItem}
                                isSubmitting={isSubmitting}
                                onSubmitClick={handleOnSubmitClick}
                            />
                        </div>
                    </>
                )}

                {showEmptyState && (
                    <>
                        <div className="flex flex-col gap-0 justify-center items-center">
                            <div className="w-80 h-80">
                                <img
                                    src={CLARIFICATION_EMPTY_STATE}
                                    className=""
                                    alt="no-data"
                                />

                            </div>
                            <label className="text-lg">No Clarification Records to show</label>
                        </div>
                    </>
                )}
            </div>
        </>
    )

}

export default ClarificationsComponent;